import URL from '@/http/achat/note-frais';
export default {
  namespaced: true,
  state: {
    steps: [
      { index: 1, libelle: 'Saisie' },
      { index: 2, libelle: 'Décision' },
    ],
    currentStep: 1,
    currentNoteFrais: null,
  },

  getters: {
    steps: (state) => state.steps,
    currentStep: (state) => state.currentStep,
    currentNoteFrais: (state) => state.currentNoteFrais,
  },

  mutations: {
    SET_CURRENT_STEP(state, value) {
      state.currentStep = value;
    },
    SET_CURRENT_NOTE_FRAIS(state, value) {
      state.currentNoteFrais = value;
    },
  },

  actions: {
    setCurrentStep({ commit }, payload) {
      let step = 1;
      switch (payload) {
        case 1:
        case 2:
          step = 2;
          break;
        default:
          step = 1;
          break;
      }
      commit('SET_CURRENT_STEP', step);
    },

    setCurrentNoteFrais({ commit }, payload) {
      commit('SET_CURRENT_NOTE_FRAIS', payload);
    },

    getNoteFrais({ commit, dispatch }, id) {
      return window.axios
        .get(URL.NOTE_FRAIS + '/' + id)
        .then((resp) => {
          commit('SET_CURRENT_NOTE_FRAIS', resp.data.note_frais);
          dispatch('setCurrentStep', resp.data.note_frais.statut);
        })
        .catch(() => {
          commit('SET_CURRENT_NOTE_FRAIS', null);
          dispatch('setCurrentStep', 1);
        });
    },
  },
};
